<div fxLayout="row" fxLayoutWrap="wrap">
  <div fxFlex.gt-sm="100%" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <mat-card-title>-ISCRIZIONE</mat-card-title>
      </mat-card-content>
     
      <mat-tab-group>
        <form [formGroup]="frmInserimento">
          <!--nuovo profilo-->
          <mat-tab label="Creare un nuovo profilo">
            <mat-card-content>

              <div class="row">
                <div fxFlex="50%;" fxFlex.xs="100%">
                  <mat-form-field class="full-width">
                    <input matInput type="text"
                           placeholder="Cognome" formControlName="Cognome" required
                           id="Cognome" />
                  </mat-form-field>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div fxFlex="50%;" fxFlex.xs="100%">
                  <mat-form-field class="full-width">
                    <input matInput type="text"
                           placeholder="Nome" formControlName="Nome" required
                           id="Nome" />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div fxFlex="50%;" fxFlex.xs="100%">
                  <mat-form-field class="full-width">
                    <input matInput type="text"
                           placeholder="Telefono" formControlName="Telefono"
                           id="Telefono" />
                  </mat-form-field>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div fxFlex="50%;" fxFlex.xs="100%">
                  <mat-form-field>
                    <input matInput type="text"
                           placeholder="Codice Fiscale" formControlName="CodiceFiscale" required
                           id="CodiceFiscale" />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <mat-form-field class="full-width">
                  <input matInput type="email"
                         placeholder="Email" formControlName="Email" required
                         id="Email" />
                  <mat-hint>Un indirizzo e-mail valido. Il sistema invierà tutte le e-mail a questo indirizzo. L'indirizzo e-mail non sarà pubblico e verrà utilizzato soltanto se desideri ricevere una nuova password o se vuoi ricevere notizie e avvisi via e-mail.</mat-hint>
                </mat-form-field>

                <!-- <mat-form-field class="full-width"></mat-form-field>-->
                <br /><br />

                <mat-form-field class="full-width">
                  <input matInput type="password"
                         placeholder="Password" formControlName="Password" required
                         id="Password" />
                </mat-form-field>
                <div *ngIf="frmInserimento.controls.Password.touched && frmInserimento.controls.Password.invalid" class="text text-danger">
                  <div *ngIf="frmInserimento.controls.Password.invalid">
                    <span>Per rendere la password più sicura:</span><br />
                    <span>- dovrebbe essere almeno di 6 caratteri.</span><br />
                    <span>- dovrebbe avere una lettera minuscola.</span><br />
                    <span>- dovrebbe avere una lettera maiuscola.</span><br />
                    <span>- dovrebbe avere un numero.</span><br />
                    <span>- dovrebbe avere un carattere speciale.</span>
                  </div>
                </div>

                <mat-form-field class="full-width">
                  <input matInput type="password"
                         placeholder="Conferma password" formControlName="ConfermaPassword" required
                         id="ConfermaPassword" />
                </mat-form-field>
                <div *ngIf="frmInserimento.controls.ConfermaPassword.touched && frmInserimento.controls.ConfermaPassword.invalid" class="text text-danger">
                  <div *ngIf="frmInserimento.controls.ConfermaPassword.errors.invalid">
                    <span>Per rendere la password più sicura:</span><br />
                    <span>- dovrebbe essere almeno di 6 caratteri.</span><br />
                    <span>- dovrebbe avere una lettera minuscola.</span><br />
                    <span>- dovrebbe avere una lettera maiuscola.</span><br />
                    <span>- dovrebbe avere un numero.</span><br />
                    <span>- dovrebbe avere un carattere speciale.</span>
                  </div>
                  <div *ngIf="frmInserimento.controls.ConfermaPassword.errors.confirmedValidator">Password e Conferma password non corrispondono.</div>
                </div>

                <fieldset>
                  <mat-form-field>
                    <mat-select formControlName="idAteneo" placeholder="Ateneo" (selectionChange)="getDipartimenti($event.value)" id="idAteneo">
                      <mat-option *ngFor="let obj of lstAtenei" [value]="obj.idAteneo">
                        {{obj.Ateneo}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-select formControlName="idDipartimento" placeholder="Dipartimento" id="idDipartimento">
                      <mat-option *ngFor="let obj of lstDipartimenti" [value]="obj.idDipartimento">
                      {{obj.Dipartimento}} 
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </fieldset>
                &nbsp;

                <mat-form-field>
                  <mat-select placeholder="Ruolo" formControlName="idRuolo" required
                              id="idRuolo">
                    <mat-option *ngFor="let obj of lstRuolo" [value]="obj.idRuolo">
                      {{obj.DescrizioneRuolo}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <section>
                  <label>Referente</label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <mat-radio-group formControlName="idReferenteTipologia">
                    <mat-radio-button *ngFor="let obj of lstReferente" [value]="obj.idReferenteTipologia">
                      {{obj.ReferenteTipologia}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </mat-radio-button>
                  </mat-radio-group>
                  <mat-hint>Profilo per referente di sede e iscrizioni collettive</mat-hint>
                </section>

                <mat-form-field>
                  <mat-select placeholder="Settore scientifico disciplinare - S.S.D." formControlName="idSettoreScientifico" required
                              id="idSettoreScientifico">
                    <mat-option *ngFor="let obj of lstSettoreScientifico" [value]="obj.idSettoreScientifico">
                      {{obj.SettoreScientificoDescrizione}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
             
                <!--  <mat-select placeholder="Riceverai la newslettter alla mail che ti sei registrato" formControlName="idTipoNewsletter" required
                              id="idTipoNewsletter">
                    <mat-option *ngFor="let obj of lstTipoNewsletter" [value]="obj.idTipoNewsletter">
                      {{obj.DescrizioneNewsletter}}
                    </mat-option>
                  </mat-select>-->
                  <label>Riceverai la newslettter alla mail che ti sei registrato.</label>
            
              </div>

              <div class="row">
                <div fxFlex="100%;" fxFlex.xs="100%">
                  <button mat-raised-button color="accent" style="float: right !important;"
                          (click)="btnCreaNuovoProfilo()">
                    Crea Nuovo Profilo
                  </button>
                </div>
              </div>

            
            </mat-card-content>
          </mat-tab>
        </form>

     

      </mat-tab-group>
     
    </mat-card>
</div>
</div>

